export const getIntials = (str: string) => {
    if (!str) return '';
    return str
        .split(' ')
        .filter(e => !!e)
        .map(str => str[0].toUpperCase())
        .join('');
};
